import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/components/Layout.vue'

import UserManagement from '@/views/PlatformManagement/UserManagement/index.vue'
import MenuManagement from '@/views/PlatformManagement/MenuManagement/index.vue'

// import wait from '@/views/wait.vue'

Vue.use(VueRouter)

// 可配置的菜单路由配置
export const menuConfig = [
  {
    id: 'user-management',
    name: '平台用户管理',
    path: '/platform-management/user-management',
    component: UserManagement,
    icon: 'el-icon-info',
    hideSave: true
  },
  {
    id: 'menu-management',
    name: '菜单管理',
    path: '/platform-management/menu-management',
    component: MenuManagement,
    icon: 'el-icon-info',
    hideSave: true
  }

  // {
  //   id: 'platform-management',
  //   name: '平台管理',
  //   icon: 'el-icon-data-analysis',
  //   children: [

  //   ]
  // }
]

// 生成路由配置
const generateRoutes = menuConfig => {
  const routes = []

  menuConfig.forEach(menu => {
    if (menu.children && menu.children.length > 0) {
      // 处理有子菜单的情况
      menu.children.forEach(child => {
        routes.push({
          path: child.path,
          name: child.id,
          component: child.component,
          meta: {
            title: child.name,
            parentId: menu.id,
            parentName: menu.name,
            icon: child.icon,
            hideSave: child.hideSave
          }
        })
      })
    } else if (menu.path && menu.component) {
      // 处理一级路由的情况
      routes.push({
        path: menu.path,
        name: menu.id,
        component: menu.component,
        meta: {
          title: menu.name,
          icon: menu.icon
        }
      })
    }
  })

  return routes
}

const routes = [
  {
    path: '/',
    component: Layout,
    children: [...generateRoutes(menuConfig)]
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes
})

export default router
